import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Switch, Typography, Autocomplete, CircularProgress, InputAdornment, TextField, IconButton, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import MyTable from '../../components/Schedule/MyTable';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './attribute-manage.css'
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import editIcon from "../../assets/edit.svg";

const AttributeManagement = () => {
	const { user } = useContext(AuthContext);
	const [loading, setLoading] = useState(false);
	const [listType, setListType] = useState('Attribute Management');
	const [name, setName] = useState('');
	const [addModal, setAddModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const [searchResult, setSearchResult] = useState('');
	const [attributeList, setAttributeList] = useState([]);
	const [deleteId, setDeleteId] = useState('');
	const [noData, setNoData] = useState(false);
	const [updateId, setUpdateId] = useState('');
	const [isEdit, setIsEdit] = useState(false);

	const columns = [
		{
			field: 'name', headerName: 'Attribute Name', flex: 1, minWidth: 130,
			valueGetter: (params) => { return params?.row?.name }
		},

		{
			field: 'Assignment_date', headerName: 'Status', flex: 1, minWidth: 150,
			renderCell: (params) => {
				return (

					<div>
						<Switch
							checked={params?.row?.is_active == 1}
							onChange={() => updateAttributeStatus(params?.row?.id, params?.row?.is_active)}
							color="primary"
						/>
					</div>
				)
			}
		},

		{
			field: 'created_at', headerName: 'Created at', flex: 1, minWidth: 200,
			valueGetter: (params) => { return varFormatTime(params?.row?.created_at, user?.Time_Format) }
		},

		{
			field: 'action', headerName: 'Actions', flex: 1, maxWidth: 130,
			renderCell: (params) => {
				return (
					<Box sx={{ display: 'flex', gap: 1 }}>
						<img src={editIcon} alt="editIcon" style={{ width: '20px', cursor: 'pointer' }}
							onClick={() => {
								updateAttributeData(params?.row?.id)
								setUpdateId(params?.row?.id)
								setIsEdit(true)
							}}
						/>
						<img src='/images/delete.svg' style={{ cursor: 'pointer' }}
							onClick={() => {
								setDeleteId(params?.row?.id)
								setDeleteModal(true)
							}}
						/>
					</Box>
				);
			},
		}
	]

	const getAttributeList = (loader = true) => {
		if (loader) {
			setLoading(true);
		}
		const body = {
			"search": searchResult
		}
		ApiService.post('/inventory/attributes', body)
			.then((data) => {
				if (data?.data?.length == 0) {
					setNoData(true)
				} else {
					setNoData(false)
				}
				setAttributeList(data?.data)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	const addAttribute = () => {
		const body = {
			'name': name,
		}
		ApiService.post('/inventory/attribute/create', body)
			.then((data) => {
				toast.success(data?.message)
				setName('');
				getAttributeList()
				setAddModal(false)
			})
			.catch((error) => {
				if (error?.status == 422) {
					Object.keys(error?.data?.errors).map((err) => (
						toast.error(error?.data?.errors[err][0])
					))
				}
				else {
					toast.error(error?.data?.message)
				}
			})
	}

	const updateAttributeData = (id) => {
		ApiService.get('/inventory/attribute/' + id)
			.then(({ data }) => {
				setLoading(false);
				setName(data?.data?.name)
				setTimeout(() => setAddModal(true), 100)
			})
			.catch(({ response }) => {
				console.error(response?.data?.message)
			})
	}

	const updateAttribute = () => {
		const body = {
			'name': name,
			'attribute_id': updateId
		}
		ApiService.post('/inventory/attribute/update', body)
			.then((data) => {
				toast.success(data?.message)
				setName('');
				setIsEdit(false)
				setAddModal(false)
				getAttributeList()
			})
			.catch((error) => {
				console.log(error, 'ppppppppppp')
				toast.error(error?.message)
			})
	}

	const deleteAttribute = () => {
		ApiService.get(`/inventory/attribute/delete/${deleteId}`)
			.then(({ data }) => {
				setDeleteModal(false)
				toast.success(data?.message)
				getAttributeList()
			})
			.catch(({ response }) => {
				toast.error(response?.data?.message)
			})
	}

	const updateAttributeStatus = (id, currStatus) => {
		const body = {
			"attribute_id": id,
			"status": currStatus == 1 ? 'false' : 'true'
		}
		ApiService.post('/inventory/attribute/status', body)
			.then((data) => {
				getAttributeList(false)
				toast.success(data?.message)
			})
			.catch((e) => {
				toast.error(e?.data?.message)
				setLoading(false);
			})
	}

	useEffect(() => {
		getAttributeList()
	}, [])

	useEffect(() => {
		setTimeout(() => getAttributeList(false), 1000)
	}, [searchResult])

	return (
		<>
			{loading ? (
				<Paper className="w-100 h-100 p-4 d-flex justify-content-center align-items-center font-fam" style={{ marginTop: "1rem" }}>
					<CircularProgress />
				</Paper>)
				:
				(<>
					<Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
						<Grid container spacing={2} className='align-items-center'>

							{/* Heading */}
							<Grid item xs={10} md={3}>
								<Typography variant="h5">Attribute Management</Typography>
							</Grid>

							<Grid item xs={6} sm={6} md={2}>
								{!noData &&
									<ButtonTheme type='submit' variant="filled" color='primary'
										onClick={() => {
											setAddModal(true)
										}}>
										Add Attributes
									</ButtonTheme>}
							</Grid>


							{/* Attribute Management Button */}
							<Grid item xs={6} sm={6} md={'auto'}>
								<Link to='/firehouse/attribute-management' style={{ textDecoration: 'none' }}>
									<div className={listType == 'Attribute Management' ? 'tab-active px-4' : 'tab-white px-4'}
										onClick={() => setListType('Attribute Management')}>
										Attribute Management
									</div>
								</Link>
							</Grid>

							{/* Entity Management Button */}
							<Grid item xs={6} sm={6} md={'auto'}>
								<Link to='/firehouse/entity-management' style={{ textDecoration: 'none' }}>
									<div className={listType == 'Entity Management' ? 'tab-active px-4' : 'tab-white px-4'}
										onClick={() => setListType('Entity Management')}>
										Entity Management
									</div>
								</Link>
							</Grid>

							{/* Search field */}
							<Grid item xs={12} sm={12} md={3}>
								{/* <TextField
									variant="outlined"
									placeholder="Search"
									onChange={(e) => setSearchResult(e.target.value)}
									className="w-100"
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton>
													<SearchIcon />
												</IconButton>
											</InputAdornment>
										),
										sx: {
											height: '48px',
											fontSize: '14px',
											marginRight: '10px',
										},
									}}
								/> */}
							</Grid>
						</Grid>

						{(attributeList && attributeList?.length == 0) && (searchResult?.length > 0) ?
							<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 325, width: "100%", marginTop: '5%'}}>
								<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
								<span className='mt-4' style={{ color: '#555555' }}>
									No attributes found
								</span>
							</div>
							:
							(!attributeList || attributeList?.length == 0) ?
								<Box>
									<div className='mt-1' style={{ color: '#555555' }}>
										No Attributes are available for any Entity.
									</div>

									<div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
										<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
										<span className='mt-4' style={{ color: '#555555' }}>
											<ButtonTheme type='submit' variant="filled" color='primary'
												onClick={() => {
													setAddModal(true)
												}}>
												Add Attributes
											</ButtonTheme>
										</span>
									</div>
								</Box>
								:
								<div className='mt-5'>
									<MyTable
										rows={attributeList}
										columns={columns}
										checkboxSelection={false}
										hideFooter={true}
									/>
								</div>}

						{/* Add Modal */}
						<Modal show={addModal} onHide={() => setAddModal(false)}>
							<Modal.Header closeButton>
								<Modal.Title> {isEdit == true ? "Update Attribute" : "Add Attribute"}</Modal.Title>
							</Modal.Header>

							<Modal.Body>
								<div style={{ color: '#555555' }}>
									{/* Name */}
									<Grid item xs={12} sm={6} md={6}>
										<label className='my-2'>Name</label>
										<TextField
											fullWidth
											variant="outlined"
											value={name}
											onChange={(e) => setName(e.target.value)}
											placeholder="Enter Name"
											sx={{
												"& .MuiInputBase-root": {
													height: "48px",
													fontSize: "14px",
													display: "flex",
													alignItems: "center"
												}
											}}
										/>
									</Grid>
								</div>
								<Row>
									<Col md='auto'>
										<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
											setDeleteModal(false)
										}}>
											Cancel
										</ButtonTheme>
									</Col>

									<Col md='auto'>
										<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
											onClick={() => {
												if (isEdit == true)
													updateAttribute()
												else
													addAttribute()
											}}>
											{isEdit == true ? "Update" : "Save"}
										</ButtonTheme>
									</Col>

								</Row>
							</Modal.Body>
						</Modal>

						{/* Delete Modal */}
						<Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
							<Modal.Header closeButton>
								<Modal.Title>Delete Attribute</Modal.Title>
							</Modal.Header>

							<Modal.Body>
								<div style={{ color: '#555555' }}>
									Are you sure you want to delete this Attribute?
								</div>
								<Row>
									<Col md='auto'>
										<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
											setDeleteModal(false)
										}}>
											Cancel
										</ButtonTheme>
									</Col>

									<Col md='auto'>
										<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
											onClick={deleteAttribute}
										>
											Delete
										</ButtonTheme>
									</Col>

								</Row>
							</Modal.Body>
						</Modal>

					</Paper>
				</>)}
		</>)
}

export default AttributeManagement